import React, { FC } from "react";
import styles from "./Brands.module.scss";
import Slider from "react-slick";
import { PageSection } from "../PageSection/PageSection";

export interface BrandsCarouselProps {
	children: React.ReactNode;
	rtl?: boolean;
}

export const BrandsCarousel: FC<BrandsCarouselProps> = ({ children, rtl }) => {
	const settings = {
		autoplay: true,
		autoplaySpeed: 2000,
		autoplayHoverPause: false,
		useTransforms: true,
		centerMode: true,
		arrows: false,
		speed: 1000,
		dots: false,
		cssEase: "ease-in-out",
		className: "sliderCard",
		infinite: true,
		slidesToShow: 5,
		variableWidth: true,
		variableHeight: false,
		slidesToScroll: 1,
		initialSlide: 0,
		accessibility: true,
		rtl: rtl,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 980,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
		],
	};
	return (
		<PageSection
			id="brands"
			heading="trusted by brands and agencies around the world"
			headingType="subtle"
			isVisuallyHiddenHeading={true}
		>
			<div className={styles.container}>
				<Slider {...settings}>
					{React.Children.map(children, (child, index) => (
						<div key={index} className={styles.slide}>
							{child}
						</div>
					))}
				</Slider>
			</div>
		</PageSection>
	);
};
